module.exports = __webpack_public_path__ + "static/media/mode.600461e6.svg";